import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '@models/contact-dialog-model';

@Component({
  selector: 'data-dialog',
  templateUrl: './data-dialog.component.html',
  styleUrls: ['./data-dialog.component.scss']
})
export class DataDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DataDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    close(response: boolean): void {
      this.dialogRef.close(response);
    }

    IsValidPhone() {
      return this.data.contactPhone 
        && this.data.contactPhone.Code 
        && this.data.contactPhone.Number 
        && this.data.contactPhone.Code.toString().length + this.data.contactPhone.Number.toString().length === 10;
    }
}
